import { Controller, useFormContext } from 'react-hook-form'

import { ctrTINTypes } from 'commons/types/dictionaries'
import { FF2, Select, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const TINType = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`institutionActivitiesInfo.${index as 0}.tinType`}
      control={control}
      rules={{
        validate: Validators.required.field
      }}
      render={({ field }) => (
        <FF2
          required
          label="60. TIN type"
          field={field}
          input={(props) => (
            <Select {...props} data={ctrTINTypes} data-qa="60. TIN type" options-data-qa="60. TIN type option" />
          )}
        />
      )}
    />
  )
}
